/**
 * Numar de telefon romanesc adus la o singura forma, si codul fiscal construit din el.
 *
 * De ce sta aici, in shared: aceeasi regula trebuie aplicata de API la salvare si de interfata
 * la previzualizare. Doua implementari care diverg ar produce exact problema pe care o evitam.
 *
 * ExpertAccounts nu accepta partener fara cod fiscal, iar pentru persoane fizice conventia din
 * EA (aceeasi ca la adaugarea manuala) e `Tel.` + numarul de telefon. Codul se compara LITERAL
 * acolo, deci `Tel.0745123456` si `Tel.+40745123456` ar fi doi parteneri pentru acelasi om —
 * de asta numarul se normalizeaza inainte de a deveni cod.
 */
/** Forma nationala: zece cifre, incepand cu 0. Null daca nu e un numar romanesc valid. */
export function numarNationalRo(phone) {
    if (!phone)
        return null;
    let d = String(phone).replace(/\D/g, '');
    if (d.startsWith('0040'))
        d = d.slice(4);
    else if (d.startsWith('40') && d.length === 11)
        d = d.slice(2);
    if (d.length === 9 && !d.startsWith('0'))
        d = '0' + d;
    return /^0\d{9}$/.test(d) ? d : null;
}
/** Codul fiscal al unei persoane fizice, in conventia EA: `Tel.0745123456`. Null daca nu se poate. */
export function codTelefonEa(phone) {
    const n = numarNationalRo(phone);
    return n ? `Tel.${n}` : null;
}
//# sourceMappingURL=telefon.js.map